const projectDatasetsSplitView = {
  archivedHint:
    "Þetta verkefni er í geymslu og eingöngu til skoðunar. Endurvektu það fyrst undir Stillingar -> Verkefnastýring.",
  empty: "Engin gagnasöfn eru enn í þessu verkefni.",
  selectAll: "Velja allt · {{count}} gagnasöfn",
  downloading: "Sæki…",
  downloadSelected: "Sækja ({{count}})",
  requestAccessOne: "Óska eftir aðgangi (1)",
  requestAccessNote:
    "Aðgangs er óskað fyrir eitt gagnasafn í einu — veldu eitt gagnasafn, eða notaðu Óska eftir aðgangi í smáatriðaskjánum.",
  rowCount: "{{value}} raðir",
  hiddenFromNonAdminsTitle: "Falið fyrir notendum sem ekki eru stjórnendur",
  expired: "Útrunnið",
  noAccess: "Enginn aðgangur",
  detailEmpty: "Veldu gagnasafn til að sjá dálka þess og samantektartölfræði.",
  downloadWorkbook: "Sækja vinnuskjal",
  downloadAsCsv: "Sækja sem CSV",
  downloadCsvHint: "Fyrsta blaðið flatt út, styður val á undirmengi dálka",
  requestAccess: "Óska eftir aðgangi",
  projectArchived: "Verkefni í geymslu",
  visibility: {
    hidden: "Falið fyrir öðrum en stjórnendum",
    visible: "Sýnilegt verkefninu",
  },
  uploadedBy: "Gagnasafni hlaðið upp af {{uploader}} þann {{date}}",
  uploadedBySomeone: "einhverjum",
  downloadFailed: "Niðurhal mistókst",
  expiryEditable: {
    set: "Gildir til {{date}}",
    none: "Enginn gildistími settur",
    edit: "Breyta",
  },
};

export default projectDatasetsSplitView;
